<script setup>
import { ref, watchEffect } from 'vue'
const props = defineProps({
  icon: { type: String, required: true },
  size: { type: [String, Number], default: 24 },
  color: { type: String, default: 'currentColor' },
})
const icons = import.meta.glob('~/assets/icons/*.svg', { query: '?raw' })
const svgContent = ref('')
watchEffect(async () => {
  const key = Object.keys(icons).find(key => key.endsWith(`/${props.icon}.svg`))
  if (!key) {
    svgContent.value = '<!-- icon not found -->'
    return
  }
  const mod = await icons[key]() // це об’єкт
  svgContent.value = typeof mod === 'object' && 'default' in mod ? mod.default : mod
})
</script>

<template>
  <span
      class="inline-block"
      v-html="svgContent"
      :style="{ width: size + 'px', height: size + 'px', fill: color }"
  />
</template>
